export const downloadFile = async (
  fileUrl: string | undefined,
  fileName: string = 'file.png'
): Promise<boolean> => {
  try {
    if (!fileUrl) return false;

    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error('Failed to download file:', error);
    return false;
  }
};

export const replaceAdvertiserIdInPath = (
  currentPath: string,
  newAdvertiserId: string
) => {
  const regex = /(\/advertiser\/)([a-fA-F0-9-]+)(\/.*|$)/;
  const match = currentPath.match(regex);

  if (match) {
    // Campaign IDs are advertiser-scoped, so they are not portable across
    // advertisers — drop the campaign segment and land on the list.
    if (/\/campaign\//.test(match[3])) {
      return `/advertiser/${newAdvertiserId}/campaigns`;
    }
    return currentPath.replace(regex, `$1${newAdvertiserId}$3`);
  }

  return `/advertiser/${newAdvertiserId}/campaigns`;
};
